/** Round to the cent; Number.EPSILON absorbs binary drift (1.005 → 1.01). Inputs are non-negative. */
export function round2(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
}
export function volumeTierPct(tier, qty) {
    if (!tier || tier.stepEvery <= 0 || qty <= 0)
        return 0;
    return Math.min(tier.maxPct, Math.floor(qty / tier.stepEvery) * tier.pctPerStep);
}
/** Yearly per-unit price: (base − min(⌊qty/stepEvery⌋, maxSteps) × step) × 12, never negative. */
export function recurringYearlyRate(rate, qty) {
    const steps = rate.stepEvery > 0 ? Math.min(Math.floor(qty / rate.stepEvery), rate.maxSteps) : 0;
    return Math.max(0, rate.baseMonthly - steps * rate.stepMonthly) * 12;
}
/** Flat fee under `flatBelowKm`; otherwise the (round-trip) distance cost rounded down and capped. */
export function travelFee(rule, km) {
    if (km < rule.flatBelowKm)
        return rule.flatFee;
    const raw = rule.perKm * km * (rule.roundTrip ? 2 : 1);
    const rounded = Math.floor(raw / rule.roundDownTo + 1e-9) * rule.roundDownTo;
    return Math.min(rule.max, rounded);
}
export function skuForQty(tiers, qty) {
    const sorted = [...tiers].sort((a, b) => a.minQty - b.minQty);
    let sku = sorted[0]?.sku ?? '';
    for (const tier of sorted)
        if (qty >= tier.minQty)
            sku = tier.sku;
    return sku;
}
export function combineDiscounts(linePct, budgetPct) {
    return round2(100 * (1 - (1 - linePct / 100) * (1 - budgetPct / 100)));
}
export function fxFactor(currency, fxRate, markupPct) {
    return currency === 'CAD' ? 1 : fxRate * (1 + markupPct / 100);
}
//# sourceMappingURL=math.js.map